import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListHistory = (params) => {
    return axios.get(`${backendHost}/api/admin/admin/history/list`, {params});
};

export {
    getListHistory
}